/* tslint:disable */
/* eslint-disable */
/* @relayHash 3742c7ef22c362cd7c0d17af56f6ea63 */

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ScorePage_studyRecordQueryVariables = {
    identifier: string;
};
export type ScorePage_studyRecordQueryResponse = {
    readonly viewer: {
        readonly " $fragmentRefs": FragmentRefs<"NavHeader_viewer" | "EmbedHeader_viewer">;
    } | null;
    readonly studyRecordByIdentifier: {
        readonly " $fragmentRefs": FragmentRefs<"StudyRecordViewer_studyRecord">;
    } | null;
};
export type ScorePage_studyRecordQuery = {
    readonly response: ScorePage_studyRecordQueryResponse;
    readonly variables: ScorePage_studyRecordQueryVariables;
};



/*
query ScorePage_studyRecordQuery(
  $identifier: String!
) {
  viewer {
    ...NavHeader_viewer
    ...EmbedHeader_viewer
  }
  studyRecordByIdentifier(identifier: $identifier) {
    ...StudyRecordViewer_studyRecord
    id
  }
}

fragment AnswerDetails_answer on Answer {
  isCorrect
  __typename
  ... on VocabAnswer {
    ...VocabAnswerDetails_answer
  }
  ... on WordOrderAnswer {
    ...WordOrderAnswerDetails_answer
  }
  ... on TranslationAnswer {
    ...TranslationAnswerDetails_answer
  }
  ... on MultipleChoiceAnswer {
    ...MultipleChoiceAnswerDetails_answer
  }
}

fragment EmbedHeader_viewer on Viewer {
  user {
    id
    username
    createdAt
  }
}

fragment FeedbackModal_viewer on Viewer {
  user {
    id
  }
}

fragment MultipleChoiceAnswerDetails_answer on MultipleChoiceAnswer {
  isCorrect
  choices {
    isChosen
    text
  }
  exercise {
    __typename
    ... on MultipleChoiceExercise {
      content {
        prompt
        choices {
          isCorrect
          text
        }
      }
    }
    id
  }
}

fragment NavHeader_viewer on Viewer {
  ...FeedbackModal_viewer
  user {
    id
    username
    isAdmin
    createdAt
    isUpgradedTeacher
    accountType
    classroomMemberships {
      level
      classroom {
        id
        title
        identifier
      }
      id
    }
    worksheets(first: 1) {
      edges {
        node {
          id
        }
      }
    }
  }
}

fragment StudyRecordViewer_studyRecord on StudyRecord {
  id
  score
  duration
  user {
    id
  }
  worksheet {
    identifier
    title
    description
    id
  }
  answers {
    __typename
    id
    ...AnswerDetails_answer
  }
}

fragment TranslationAnswerDetails_answer on TranslationAnswer {
  isCorrect
  response
  exercise {
    __typename
    ... on TranslationExercise {
      content {
        prompt
        correctAnswers
        scrambledParts
      }
    }
    id
  }
}

fragment VocabAnswerDetails_answer on VocabAnswer {
  isCorrect
  correctTerm {
    word
    definition
    image {
      url(size: SMALL_SQUARE)
      id
    }
  }
  responseTerm {
    word
    definition
    image {
      url(size: SMALL_SQUARE)
      id
    }
  }
}

fragment WordOrderAnswerDetails_answer on WordOrderAnswer {
  isCorrect
  response
  exercise {
    __typename
    ... on WordOrderExercise {
      content {
        correctAnswers
        scrambledParts
      }
    }
    id
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "identifier",
    "type": "String!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "identifier",
    "variableName": "identifier"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "title",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "identifier",
  "args": null,
  "storageKey": null
},
v5 = [
  (v2/*: any*/)
],
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "isCorrect",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "__typename",
  "args": null,
  "storageKey": null
},
v8 = [
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "word",
    "args": null,
    "storageKey": null
  },
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "definition",
    "args": null,
    "storageKey": null
  },
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "image",
    "storageKey": null,
    "args": null,
    "concreteType": "Image",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "url",
        "args": [
          {
            "kind": "Literal",
            "name": "size",
            "value": "SMALL_SQUARE"
          }
        ],
        "storageKey": "url(size:\"SMALL_SQUARE\")"
      },
      (v2/*: any*/)
    ]
  }
],
v9 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "response",
  "args": null,
  "storageKey": null
},
v10 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "correctAnswers",
  "args": null,
  "storageKey": null
},
v11 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "scrambledParts",
  "args": null,
  "storageKey": null
},
v12 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "prompt",
  "args": null,
  "storageKey": null
},
v13 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "text",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "ScorePage_studyRecordQuery",
    "type": "Root",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "NavHeader_viewer",
            "args": null
          },
          {
            "kind": "FragmentSpread",
            "name": "EmbedHeader_viewer",
            "args": null
          }
        ]
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "studyRecordByIdentifier",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "StudyRecord",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "StudyRecordViewer_studyRecord",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "ScorePage_studyRecordQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "user",
            "storageKey": null,
            "args": null,
            "concreteType": "User",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "username",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "isAdmin",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "createdAt",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "isUpgradedTeacher",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "accountType",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "classroomMemberships",
                "storageKey": null,
                "args": null,
                "concreteType": "ClassroomMembership",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "level",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "classroom",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Classroom",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v3/*: any*/),
                      (v4/*: any*/)
                    ]
                  },
                  (v2/*: any*/)
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "worksheets",
                "storageKey": "worksheets(first:1)",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 1
                  }
                ],
                "concreteType": "WorksheetConnection",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "WorksheetEdge",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Worksheet",
                        "plural": false,
                        "selections": (v5/*: any*/)
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "studyRecordByIdentifier",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "StudyRecord",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "score",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "duration",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "user",
            "storageKey": null,
            "args": null,
            "concreteType": "User",
            "plural": false,
            "selections": (v5/*: any*/)
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "worksheet",
            "storageKey": null,
            "args": null,
            "concreteType": "Worksheet",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v3/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "description",
                "args": null,
                "storageKey": null
              },
              (v2/*: any*/)
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "answers",
            "storageKey": null,
            "args": null,
            "concreteType": null,
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              {
                "kind": "InlineFragment",
                "type": "VocabAnswer",
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "correctTerm",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "VocabAnswerTerm",
                    "plural": false,
                    "selections": (v8/*: any*/)
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "responseTerm",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "VocabAnswerTerm",
                    "plural": false,
                    "selections": (v8/*: any*/)
                  }
                ]
              },
              {
                "kind": "InlineFragment",
                "type": "WordOrderAnswer",
                "selections": [
                  (v9/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "exercise",
                    "storageKey": null,
                    "args": null,
                    "concreteType": null,
                    "plural": false,
                    "selections": [
                      (v7/*: any*/),
                      (v2/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "type": "WordOrderExercise",
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "content",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "WordOrderExerciseContent",
                            "plural": false,
                            "selections": [
                              (v10/*: any*/),
                              (v11/*: any*/)
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "InlineFragment",
                "type": "TranslationAnswer",
                "selections": [
                  (v9/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "exercise",
                    "storageKey": null,
                    "args": null,
                    "concreteType": null,
                    "plural": false,
                    "selections": [
                      (v7/*: any*/),
                      (v2/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "type": "TranslationExercise",
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "content",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "TranslationExerciseContent",
                            "plural": false,
                            "selections": [
                              (v12/*: any*/),
                              (v10/*: any*/),
                              (v11/*: any*/)
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "InlineFragment",
                "type": "MultipleChoiceAnswer",
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "choices",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "MultipleChoiceAnswerChoice",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "isChosen",
                        "args": null,
                        "storageKey": null
                      },
                      (v13/*: any*/)
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "exercise",
                    "storageKey": null,
                    "args": null,
                    "concreteType": null,
                    "plural": false,
                    "selections": [
                      (v7/*: any*/),
                      (v2/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "type": "MultipleChoiceExercise",
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "content",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "MultipleChoiceExerciseContent",
                            "plural": false,
                            "selections": [
                              (v12/*: any*/),
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "choices",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "MultipleChoiceExerciseChoice",
                                "plural": true,
                                "selections": [
                                  (v6/*: any*/),
                                  (v13/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "ScorePage_studyRecordQuery",
    "id": null,
    "text": "query ScorePage_studyRecordQuery(\n  $identifier: String!\n) {\n  viewer {\n    ...NavHeader_viewer\n    ...EmbedHeader_viewer\n  }\n  studyRecordByIdentifier(identifier: $identifier) {\n    ...StudyRecordViewer_studyRecord\n    id\n  }\n}\n\nfragment AnswerDetails_answer on Answer {\n  isCorrect\n  __typename\n  ... on VocabAnswer {\n    ...VocabAnswerDetails_answer\n  }\n  ... on WordOrderAnswer {\n    ...WordOrderAnswerDetails_answer\n  }\n  ... on TranslationAnswer {\n    ...TranslationAnswerDetails_answer\n  }\n  ... on MultipleChoiceAnswer {\n    ...MultipleChoiceAnswerDetails_answer\n  }\n}\n\nfragment EmbedHeader_viewer on Viewer {\n  user {\n    id\n    username\n    createdAt\n  }\n}\n\nfragment FeedbackModal_viewer on Viewer {\n  user {\n    id\n  }\n}\n\nfragment MultipleChoiceAnswerDetails_answer on MultipleChoiceAnswer {\n  isCorrect\n  choices {\n    isChosen\n    text\n  }\n  exercise {\n    __typename\n    ... on MultipleChoiceExercise {\n      content {\n        prompt\n        choices {\n          isCorrect\n          text\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment NavHeader_viewer on Viewer {\n  ...FeedbackModal_viewer\n  user {\n    id\n    username\n    isAdmin\n    createdAt\n    isUpgradedTeacher\n    accountType\n    classroomMemberships {\n      level\n      classroom {\n        id\n        title\n        identifier\n      }\n      id\n    }\n    worksheets(first: 1) {\n      edges {\n        node {\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment StudyRecordViewer_studyRecord on StudyRecord {\n  id\n  score\n  duration\n  user {\n    id\n  }\n  worksheet {\n    identifier\n    title\n    description\n    id\n  }\n  answers {\n    __typename\n    id\n    ...AnswerDetails_answer\n  }\n}\n\nfragment TranslationAnswerDetails_answer on TranslationAnswer {\n  isCorrect\n  response\n  exercise {\n    __typename\n    ... on TranslationExercise {\n      content {\n        prompt\n        correctAnswers\n        scrambledParts\n      }\n    }\n    id\n  }\n}\n\nfragment VocabAnswerDetails_answer on VocabAnswer {\n  isCorrect\n  correctTerm {\n    word\n    definition\n    image {\n      url(size: SMALL_SQUARE)\n      id\n    }\n  }\n  responseTerm {\n    word\n    definition\n    image {\n      url(size: SMALL_SQUARE)\n      id\n    }\n  }\n}\n\nfragment WordOrderAnswerDetails_answer on WordOrderAnswer {\n  isCorrect\n  response\n  exercise {\n    __typename\n    ... on WordOrderExercise {\n      content {\n        correctAnswers\n        scrambledParts\n      }\n    }\n    id\n  }\n}\n",
    "metadata": {}
  }
};
})();
(node as any).hash = '3871a4f2febcc959b255d1cfef59863e';
export default node;
